fragment ParentChildFragment on Account {
    id
    name
    description
    accountType {
        id
        name
    }
    primaryAddressRegion
    avatarUrl
    htmlUrlPath
    primaryContact {
        id
        name
    }
}
